import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
// import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import useRequest from "../../../context/useRequest";

const LoginForm = () => {
    const { data: isLoginData, sendRequest } = useRequest();
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [isLogin, setIsLogin] = useState({
        email: '',
        password: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isLoginData) {
            setIsLogin({
                email: isLoginData.email,
                password: isLoginData.password
            });
        }
    }, [isLoginData]);
    // Handles input changes for the login form field
    const loginHandler = (e) => {
        const { name, value } = e.target;
        setIsLogin(prev => ({
            ...prev,
            [name]: value
        }));
        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            email: "",
            password: "",
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (!isLogin.email) errors.email = "Email is required";
        if (!isLogin.password) errors.password = "Password is required";
        return errors;
    };

    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setIsFieldErrors(errors);
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);
        setIsFieldErrors({});
        const formLogin = new FormData();
        formLogin.append("email", isLogin.email);
        formLogin.append("password", isLogin.password);

        try {
            const response = await sendRequest({
                method: "POST",
                url: "/auth/login",
                body: formLogin,
            });

            if (response?.success) {
                // setIsLoggedIn(true);
                login();
                navigate('/');
            } else {
                setIsLogin((prevLogin) => ({
                    ...prevLogin,
                    password: "",
                }));
                setIsFieldErrors((prevErrors) => ({
                    ...prevErrors,
                    email: response?.data?.emailPassword || "Invalid email or password",
                    password: response?.data?.emailPassword || "Invalid email or password",
                }));
            }
        } catch (error) {
            setIsLogin((prevLogin) => ({
                ...prevLogin,
                password: "",
                email: "",
            }));
            setIsFieldErrors({
                email: error.response?.data?.message || "An unexpected error occurred.",
                password: error.response?.data?.message || "An unexpected error occurred.",
            });
        } finally {
            setIsSubmitting(false);
        }
    };


    // if (isLoggedIn) {
    //     return <Navigate to="/" />;
    // }

    return (
        <form onSubmit={loginSubmitHandler} className="login-form--item-left-form mt-4">
            <div className="form-group input-group login-form--item-left-form-input">
                <Input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={isLogin.email}
                    onChange={loginHandler}
                    className="form-control"
                    label={
                        <span>
                            Email Address <span style={{ color: "red" }}>*</span>
                        </span>
                    }
                />
                {isFieldErrors.email && (
                    <p className="error-message">{isFieldErrors.email}</p>
                )}
            </div>
            <div className="form-group input-group login-form--item-left-form-input">
                <Input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={isLogin.password}
                    onChange={loginHandler}
                    className="form-control"
                    label={
                        <span>
                            Password <span style={{ color: "red" }}>*</span>
                        </span>
                    }
                />
                {isFieldErrors.password && (
                    <p className="error-message">{isFieldErrors.password}</p>
                )}
            </div>
            <div className="form-group d-flex justify-content-between align-items-center login-form--item-left-form-input">
                {/* <div className="login-form--item-left-form-input--remember">
                    <label className="d-flex align-items-center">
                        <input type="checkbox" name="checkbox" /> Remember Me
                    </label>
                </div> */}
                <div className="login-form--item-left-form-input-password">
                    <a href="/forget-password">Forgot Password?</a>
                </div>
            </div>
            <div className="form-group login-form--item-left-form-submit">
                <button type="submit" className="submit">Submit</button>
            </div>
        </form>
    );
};

export default LoginForm;